import { render, staticRenderFns } from "./AsociarEventosFormEdit2.vue?vue&type=template&id=4f517abd&scoped=true&"
import script from "./AsociarEventosFormEdit2.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosFormEdit2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosFormEdit2.vue?vue&type=style&index=0&id=4f517abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f517abd",
  null
  
)

export default component.exports